// extracted by mini-css-extract-plugin
export default {"container":"lcjGwF","logoContainer":"A4vdL4","logo":"D4se1F"};